import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import Inconvenientes from "./inconvenientes.cmpt";
import Completar from "./completar.cmpt";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.asistido.paso,
		stageValido: state.registro.paso
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoAsistido: () => {
			dispatch({ "type": "REGISTRO_PASO", paso: 1 });
			dispatch({ "type": "LIMPIAR_REGISTRO_ASISTIDO" });
		}
	};
};

class Flujo extends React.Component {
	atras = () => {
		goTo("registro");
		//window.location.href = '/#!/registro';
	}
	
	componentWillMount = () => {
		if(this.props.stageValido == 1) {
			this.props.pasoAsistido();
		} else {
			this.atras();
		}
	}
	
	render() {
		return (
			<div className="login-wrap">
				<div className="container">
					<div className="ayuda-wrap">
						<p>¿Tienes duda de cómo utilizar el portal? <a href="">Ver tutorial</a></p>
					</div>
					<div className="login-box">
						{ this.props.paso == 0 && 
							<div>
								<div className="pasos-wrap">
									<a onClick={this.atras.bind(this)} className="pull-left">
										<img src={ require("../img/arrow-back.png") } alt="" />
									</a>
									<img src={ require("../img/datos_activo.svg") } alt="" />
								</div>
								<Completar />
							</div>
						}
						{ this.props.paso == 1 && 
							<Inconvenientes />
						}
					</div>
				</div>
			</div>
        );
	};
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/registro-asistido/flujo.cmpt.js